import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getParam, useAuthProvider } from "@cloudpremise/portal_core";
import MDBox from "@cloudpremise/portal_core/src/themes/mui/components/MDBox";
import MDButton from "@cloudpremise/portal_core/src/themes/mui/components/MDButton";
import DashboardLayout from "@cloudpremise/portal_core/src/themes/mui/examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "@cloudpremise/portal_core/src/themes/mui/examples/Navbars/DashboardNavbar";

import DynamicObjectForm from "../components/DynamicObjectForm";

// @mui material components
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";

import "../styles/home.scss";

const Home = (props) => {
    const [ authorized, authType, token ] = useAuthProvider();
    const { dynamicFormType, id } = useParams();
    const objectTypeId = getParam("objectTypeId");
    const objectId = getParam("objectId");
    let formType = null;
    let Id = null;
    if(typeof(dynamicFormType) === "string" && dynamicFormType.length > 0){
        formType = dynamicFormType;
    }
    if(typeof(objectTypeId) === "string" && objectTypeId.length > 0){
        formType = objectTypeId;
    }
    if(typeof(id) === "string" && id.length > 0){
        Id = id;
    }
    if(typeof(objectId) === "string" && objectId.length > 0){
        Id = objectId;
    }
    const defaultState = {
        dynamicFormType: formType,
        Id: Id
    }
    const [state, setState] = React.useReducer((state: any, newState: Partial<any>) => ({
        ...state,
        ...newState
    }), defaultState);

    const navigate = useNavigate();
    React.useEffect(() => {
        // if(!authorized){
        //     return navigate("/landing"+window.location.search, { replace: true });
        // }
        // if(authorized && (authType !== "link" && authType !== "microsoft" && authType !== "google" && authType !== "github" && authType !== "facebook")){
        //     return navigate("/auth-not-supported", { replace: true });
        // }
    });

    function onSuccess(){
        setState({
            dynamicFormType: null
        })
    }
    // console.log(dynamicFormType);
    // console.log(objectTypeId);
    // console.log("Id = "+Id);
    // if(!authorized){
    //     return null;
    // }
    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox my={3}>
                <Grid container justifyContent="flex-start" alignItems="flex-start">
                    <Grid item xs={12} md={12} lg={12} mr="auto" position="relative">
                        {
                            state.dynamicFormType !== null ?
                                <DynamicObjectForm
                                    objectType={state.dynamicFormType}
                                    Id={Id}
                                    onSuccess={() => onSuccess()}
                                    onCancel={() => onSuccess()}
                                    saveButtonText={
                                        (Id && Id.length > 0 ? 'Save Changes' : 'Submit')
                                    }
                                />
                            :
                                <div className="welcome-container">
                                    <div className="welcome-card">
                                        <h2>Welcome to Dynamic Forms</h2>
                                        <p>Pass the given Parameters in url for working Forms</p>
                                        <ul>
                                            <li>Latest Schema of a Form Type: forms/{'{apiName}'}</li>
                                            <li>Latest Schema of a Form Type: forms/{'{apiName}'}?objectTypeId=abc123</li>
                                            <li>Schema of Entered Id Form Type: forms?objectTypeId=abc123</li>
                                            <li>Edit/View Form: forms?objectTypeId=abc123&objectId=abc123</li>
                                            <li>Edit/View Form: forms/{'{apiName}'}?objectId=abc123 (For DynamicObject storage type only)</li>
                                        </ul>
                                        {/* <MDButton color="info">Get Started</MDButton>                                 */}
                                    </div>
                                </div>
                        }
                    </Grid>
                </Grid>
            </MDBox>
        </DashboardLayout>
    )
}

export default Home;